import axios from 'axios'
import { UserListResponse } from 'src/models/user.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

interface ManagerAssignment {
  organizationId: string
  userId: string
  manager?: UserListResponse
}

export interface PeopleManagerResponse {
  managerAssignment: ManagerAssignment
}

export interface PeopleManagerDirectReportsResponse {
  // list of user IDs
  directReports: string[]
}

export interface PeopleManagersCountResponse {
  count: number
}

export const getPeopleManager = async (
  organizationId: string,
  userId: string,
): Promise<PeopleManagerResponse> =>
  getResponseData(
    axios.get<PeopleManagerResponse>(
      `/organizations/${organizationId}/members/${userId}/managerassignment`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getPeopleManagerDirectReports = async (
  organizationId: string,
  userId: string,
): Promise<PeopleManagerDirectReportsResponse> =>
  getResponseData(
    axios.get<PeopleManagerDirectReportsResponse>(
      `/organizations/${organizationId}/members/${userId}/directreports`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getPeopleManagersCount = async (
  organizationId: string,
): Promise<PeopleManagersCountResponse> =>
  getResponseData(
    axios.get<PeopleManagersCountResponse>(
      `/organizations/${organizationId}/managers/count`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
